// extracted by mini-css-extract-plugin
export default {"container":"no-sub-page_container__d9Qk4","text":"no-sub-page_text__42u8b","button":"no-sub-page_button__PMg8R"};